import {EventParticipant} from "../providers/communication/models/EventParticipant";


export class EventFeatures {

  static readonly STATUS_DISABLED: number = 0;
  static readonly STATUS_ENABLED: number = 1;
  static readonly STATUS_LIVE: number = 2;

  get chat() {
    return this._chatStatus;
  }

  get feed() {
    return this._feedStatus;
  }

  get schedule() {
    return this._scheduleStatus;
  }

  constructor(private _chatStatus: FeatureStatus,
              private _feedStatus: FeatureStatus,
              private _scheduleStatus: FeatureStatus) {
  }

  static fromJson({chat, feed, schedule}) : EventFeatures {
    return new EventFeatures(
      EventFeatures._getFeatureStatus(chat),
      EventFeatures._getFeatureStatus(feed),
      EventFeatures._getFeatureStatus(schedule)
    );
  }


  private static _getFeatureStatus(data: {defaultAccess, minRoleRequired, groupMinRoleRequired, status}) : FeatureStatus {
    if (data) {
      return {
        defaultAccess: data.defaultAccess,
        status: data.status,
        minRoleRequired: data.minRoleRequired,
        groupMinRoleRequired: data.groupMinRoleRequired || null
      }
    } else {
      return {
        defaultAccess: EventParticipant.CHAT_ACCESSIBILITY_DISABLED,
        status: EventFeatures.STATUS_DISABLED,
        minRoleRequired: EventParticipant.ROLE_PARTICIPANT
      }
    }
  }

}

export interface FeatureStatus {
  defaultAccess: number,
  status: number,
  minRoleRequired: number,
  groupMinRoleRequired?: number
}



// WEBPACK FOOTER //
// ./src/models/EventFeatures.ts